import React from 'react';

import { MapTo } from '@adobe/aem-spa-component-mapping';

import { BulletList } from 'components/ExpertSearch/components/BulletList/BulletList';
import { MailHotline } from 'components/ExpertSearch/components/MailHotline/MailHotline';
import { PageTitleSection } from 'components/PageTitleSection/PageTitleSection';

export const ZaehlerTab = () => {
  return (
    <div className="expert-page einspeiseranschluss">
      <div className="expert-page-content-stage-text">
        <PageTitleSection title="Zählerkontakt" notFramed />
        <MailHotline>
          <p>
            Postfach:{' '}
            <a href="mailto:zaehlerkontakt@lew-verteilnetz.de">zaehlerkontakt@lew-verteilnetz.de</a>
          </p>

          <p>Hotline: 0800/539638-7</p>
        </MailHotline>

        <BulletList
          title="Themen"
          items={
            <>
              <li>Abgelaufener QR Code - Paketversand</li>
              <li>Nicht zurückgemeldete Zähler, Abgelaufener QR Code Rückmeldeportal</li>
              <li>Fragen zum Zählerversand nach Fertigmeldungsbestätigung</li>
              <li>Fragen zu ZdI</li>
              <li>Wer installiert meinen Zähler</li>
            </>
          }
        />
        <BulletList
          title="Was gehört nicht zum Zählerkontakt"
          items={
            <>
              <li>Fragen zum Messkonzept</li>
              <li>Fragen zur Anmeldung</li>
              <li>Fragen zum Stand der Anmeldung</li>
              <li>Fragen zu iConnect</li>
              <li>Fragen zur Abrechnung</li>
            </>
          }
        />
        <PageTitleSection title="Technische Fragen zu den TAB" notFramed />
        <MailHotline>
          <p>
            Postfach: <a href="mailto:tab@lew-verteilnetz.de">tab@lew-verteilnetz.de</a>
          </p>

          <p>Hotline: 0821/328-1590</p>
        </MailHotline>

        <BulletList
          title="Themen"
          items={
            <>
              <li>Fragen allgemein Technische Anschlussbedingungen TAB</li>
              <li>Fragen zum Aufbau von Wandlermessungen</li>
              <li>Fragen zum §14a EnWG</li>
              <li>Fragen allgemein zu netzrelevanten Normen und Anwendungsregeln</li>
            </>
          }
        />
        <BulletList
          title="Was gehört nicht zur TAB"
          items={
            <>
              <li>Bestellungen/Abbestellungen Freileitungsisolierung</li>
              <li>Fragen zu Abrechnung / Vergütung</li>
              <li>Fragen zum Bearbeitungsstand</li>
              <li>Fragen zur Benutzung von iConnect</li>
              <li>Fragen zum Ablesen der Zähler</li>
            </>
          }
        />
      </div>
    </div>
  );
};
MapTo('e-fix/components/content/zaehlertab')(ZaehlerTab);
